import * as moment from "moment";


export const phoneRegex = /^\d{3}-\d{3}-\d{4}(x\d{1,5})?$/;
export const zipRegex = /^([0-9]{5})(?:[-\s]([0-9]{4}))?$/;
export const dateCantBeInFuture = moment().add(0, "days");
export const minimumYearsOld = (years) => moment().add(years, "years");
export const maxYearAgo = years => moment().subtract(years, "years");
export const dateIsBefore = (before, after) => moment(before).isSameOrBefore(after);
export const cityRegEx = /^[a-zA-Z',.\s-]{1,25}$/;
export const stateRegEx = /^[a-zA-Z]{2}$/;


